interface RedirectUrlParams {
    target?: string;
}

const redirectUrl = (config: RedirectUrlParams) => {
    const { target } = config;
    console.log(target,'===target===');
    if(target){
        window.location.replace(target);
    }
}

export default redirectUrl;